export default __webpack_public_path__ + "static/media/tax.54d09f20.webp";